import gql from "graphql-tag";

export const LIST_STOCK_TRANSFERS = gql`
  query stockTransfers($filter: StockTransfersFilter, $pagination: PaginationInput) {
    stockTransfers(filter: $filter, pagination: $pagination) {
      entries {
        id
        status
        adviceSent
        adviceSentAt
        archived
        originWarehouseId
        destinationWarehouseId
        transportType
        carrierReference
        purchaseOrder
        expectedArrivalDate
        dispatchedAt
        receivedAt
        cancelledAt
      }
      metadata {
        before
        after
        limit
      }
    }
  }
`;

export const GET_STOCK_TRANSFER = gql`
  query stockTransfer($id: ID!) {
    stockTransfer(id: $id) {
      id
      status
      imported
      editable
      discarded
      discardable
      adviceSent
      adviceSentAt
      adviceSentBy
      archived
      adviceReference
      originWarehouseId
      destinationWarehouseId
      transportType
      carrierReference
      purchaseOrder
      orderDate
      expectedArrivalDate
      dispatchedAt
      receivedAt
      cancelledAt
      totalQuantity
      lines {
        id
        palletId
        kind
        sku
        stockSku
        quantity
        receivedQuantity
        serialNrs
      }
    }
  }
`;


// The transfer as a shipment advice: JSON in the shape of the old advice files,
// fetched on demand (it carries every serial number).
export const GET_STOCK_TRANSFER_SHIPMENT_ADVICE = gql`
  query stockTransferShipmentAdvice($id: ID!) {
    stockTransfer(id: $id) {
      id
      shipmentAdvice
    }
  }
`;

export const ON_STOCK_TRANSFER_UPDATED = gql`
  subscription onStockTransferUpdated {
    stockTransferUpdated {
      id
    }
  }
`;
